module.exports = __webpack_public_path__ + "static/media/55.3d4d377a.jpg";